import { modelsCompFn } from '@/lib/filter/base-frontend-filter/scope';

export const spaceFn = ({ propertyValues, scope }) => {
  const models = propertyValues.find((pv) => pv.property.uid === scope.property.uid)?.spaces;
  const neededModels = scope.spaces;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};

export const directSpaceFn = ({ entity, scope }) => {
  const models = entity[scope.directProperty.edgeName];
  const neededModels = scope.spaces;
  return modelsCompFn({ models, neededModels, isEmpty: scope.isEmpty });
};
